//Creates tooltip and makes it invisiblae
var div = d3.select(".gia-chart").append("div")
    .attr("class", "tooltip")
    .style("opacity", 0);

//Sets dimensions
var margin = {top: 0, left: 5, bottom: 5, right: 5},
  width = d3.select(".gia-chart").node().clientWidth,
  width = width - margin.left - margin.right,
  mapRatio = .65,
  height = width * mapRatio;

//Tells the map what projection to use
var projection = d3.geo.albersUsa()
  .scale(width *1.25)
  .translate([width / 2, height / 2]);

//Tells the map how to draw the paths from the projection
var path = d3.geo.path()
  .projection(projection);

//Sets the color scale
var color_domain = [10, 20, 30 ,40];
var ext_color_domain = [0, 10, 20, 30 ,40]; 
var color = d3.scale.threshold() 

.domain(color_domain)
.range(['#e0f4f9','#c2e9f2','#a0ddec','#7bd2e5','#4bc6df']);

//Appened svg to page
var map = d3.select(".gia-chart").append("svg")
  .style('height', height + 'px')
  .style('width', width + 'px');  

//Load the files
queue()
  .defer(d3.json, "data/usmap.json")
  .defer(d3.csv, "data/states.csv")
  .await(ready);

//Moves selection to front
d3.selection.prototype.moveToFront = function() {
  return this.each(function(){
    this.parentNode.appendChild(this);
  });
}; 

//Moves selection to back
d3.selection.prototype.moveToBack = function() { 
  return this.each(function() { 
    var firstChild = this.parentNode.firstChild; 
      if (firstChild) { 
        this.parentNode.insertBefore(this, firstChild); 
      } 
    }); 
  }; 

function ready(error, us, maptemplate) {
  if (error) throw error;  
 
  //Pair data with state id
  var dataByFIPS = {};
  maptemplate.forEach(function(d) { dataByFIPS[d.FIPS] = d.num; });

  //Pair state name with state id
  var stateByFIPS = {};
  maptemplate.forEach(function(d) { stateByFIPS[d.FIPS] = d.state; });

  //Append states
  map.append("g")
    .attr("class", "states")
    .selectAll("path")
    .data(topojson.feature(us, us.objects.states).features)
    .enter().append("path")
    .attr("d", path)
    .style("fill", function(d) { return color (dataByFIPS[d.id]); })

    /*Hovers
    .on("mouseover", function(d) {
      var sel = d3.select(this);
        sel.moveToFront();
      d3.select(this)
        .transition().duration(300).style({'opacity': 1, 'stroke': '#333333', 'stroke-width': 1.5});
      div.transition().duration(300)
        .style("opacity", 1)
      div.text(dataByFIPS[d.id] + "% of " + stateByFIPS[d.id] +"'s eligible voters are Latino");
    })

    .on("mouseout", function() {
      var sel = d3.select(this);
        sel.moveToBack();
      d3.select(this)
        .transition().duration(300).style({'opacity': 1, 'stroke': 'white', 'stroke-width': 1});
      div.transition().duration(300)
        .style("opacity", 0);
    }) 
    */

    //Select FL
    map.append("path")
    .datum(topojson.mesh(us, us.objects.states, function(a, b) { return a.id == "12" || b.id == "12"; }))
    .attr("d", path)
    .attr("class", "outline");

    //Select AZ
    map.append("path")
    .datum(topojson.mesh(us, us.objects.states, function(a, b) { return a.id == "4" || b.id == "4"; }))
    .attr("d", path)
    .attr("class", "outline");

    //Select NM
    map.append("path")
    .datum(topojson.mesh(us, us.objects.states, function(a, b) { return a.id == "32" || b.id == "32"; }))
    .attr("d", path)
    .attr("class", "outline");

    //FL label
    var fl_label = map.append("text")
      .attr("class", "FL-label")
      .attr("y", (width * mapRatio)/1.25);

    var fl_label_state = fl_label.append('tspan')
      .attr("class", "FL-tspan-state")
      .text("FL")
      .attr("x", width/1.22)

    var fl_label_num = fl_label.append('tspan')
      .attr("class", "FL-tspan-num")
      .attr("dy", 16)
      .text("18.1")
      .attr("x", width/1.22);  

    //NV label
    var nv_label = map.append("text")
      .attr("class", "NV-label")
      .attr("y", (width * mapRatio)/2.475);

    var nv_label_state = nv_label.append('tspan')
      .attr("class", "NV-tspan-state")
      .text("NV")
      .attr("x", width/6.9)

    var nv_label_num = nv_label.append('tspan')
      .attr("class", "NV-tspan-num")
      .attr("dy", 16)
      .text("17.2")
      .attr("x", width/6.9); 

    //AZ label
    var az_label = map.append("text")
      .attr("class", "AZ-label")
      .attr("y", (width * mapRatio)/1.675);

    var az_label_state = az_label.append('tspan')
      .attr("class", "AZ-tspan-state")
      .text("AZ")
      .attr("x", width/4.75)

    var az_label_num = az_label.append('tspan')
      .attr("class", "AZ-tspan-num")
      .attr("dy", 16)
      .text("21.5")
      .attr("x", width/4.75);       

  //RESPONSIVENESS
  d3.select(window).on('resize', resize);

  function resize() {

    var w = d3.select(".gia-chart").node().clientWidth;

    //Adjust things when the window size changes
    width = w - margin.left - margin.right;
    height = width * mapRatio;
    
    //Update projection
    var newProjection = d3.geo.albersUsa()
      .scale(width*1.25)
      .translate([width / 2, height / 2]);

    //Update path
    path = d3.geo.path()
      .projection(newProjection);    

    //Resize the map container
    map
      .style('width', width + 'px')
      .style('height', height + 'px');

    //Resize the map
    map.selectAll("path").attr('d', path);

    //Replace FL label
    map.selectAll(".FL-label")
      .attr("x", width/1.25)
      .attr("y", (width * mapRatio)/1.25);

    map.selectAll(".FL-tspan-state")
      .attr("x", width/1.22)
      .attr("y", (width * mapRatio)/1.25); 

    map.selectAll(".FL-tspan-num")
      .attr("x", width/1.22)
      .attr("y", (width * mapRatio)/1.25);    

    //Replace NV label
    map.selectAll(".NV-label")
      .attr("x", width/6.9)
      .attr("y", (width * mapRatio)/2.475);

    map.selectAll(".NV-tspan-state")
      .attr("x", width/6.9)
      .attr("y", (width * mapRatio)/2.475); 

    map.selectAll(".NV-tspan-num")
      .attr("x", width/6.9)
      .attr("y", (width * mapRatio)/2.475);       

    //Replace AZ label
    map.selectAll(".AZ-label")
      .attr("x", width/4.75)
      .attr("y", (width * mapRatio)/1.675);

    map.selectAll(".AZ-tspan-state")
      .attr("x", width/4.75)
      .attr("y", (width * mapRatio)/1.675); 

    map.selectAll(".AZ-tspan-num")
      .attr("x", width/4.75)
      .attr("y", (width * mapRatio)/1.675);  
  }
}